import { useLang } from 'hooks/lang';

import { getProjectAmountTaken } from 'entities';
import { Column, Row } from 'components/Blocks';
import { CircleDollarIcon, DollarBillIcon } from 'components/Icons';

import { formatCurrency } from 'utils/text';

import { StatusInfoComponent } from './types';

export const AmountTaken: StatusInfoComponent = ({ control }) => {
  const { t } = useLang();

  const taken = getProjectAmountTaken(control);

  return (
    <Column gap="2">
      <Row gap="2">
        <DollarBillIcon color="success-light" size={20} />

        <Column gap="0">
          <span className="text-sm phone:hidden">{t('amount-taken')}</span>

          <span className="text-sm font-semibold">
            {formatCurrency(taken, control.project.currency)}
          </span>
        </Column>
      </Row>

      <Row gap="2">
        <CircleDollarIcon size={20} />

        <Column gap="0">
          <span className="text-sm phone:hidden">{t('project-total')}</span>

          <span className="text-sm font-semibold">
            {formatCurrency(control.project.total, control.project.currency)}
          </span>
        </Column>
      </Row>
    </Column>
  );
};
